declare global {
  interface Window {
    gtag?: (
      command: 'event',
      action: string,
      params: {
        send_to: string;
        event_callback?: () => void;
      },
    ) => void;
  }
}

const GTAG_CONVERSION_ID = 'AW-16558983468/uhJFCOyRmt4ZEKyS-Nc9';

export const trackGoogleAdsConversion = (url?: Location | (string & Location)): void => {
  if (typeof window !== 'undefined' && window.gtag) {
    const callback = () => {
      if (typeof url !== 'undefined') {
        window.location = url;
      }
    };

    window.gtag('event', 'conversion', {
      send_to: GTAG_CONVERSION_ID,
      event_callback: callback,
    });
  }
};

export const trackGoogleAdsPageLoad = (): void => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: GTAG_CONVERSION_ID,
    });
  }
};
